'use client';

import { useRef, useState } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import TestimonialsList, {
  NavigationRef,
} from './TestimonialsList/TestimonialsList';

import styles from './testimonialsInner.module.scss';
import { useVisible } from '@/hooks';
import { ArrowButton } from '@/components';

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const TestimonialsInner = ({
  slice,
}: {
  slice: Content.TestimonialsSlice;
}) => {
  const [isVisible, id] = useVisible();
  const [slideNumber, setSlideNumber] = useState({ first: true, last: false });

  const navigationRef = useRef<NavigationRef>(null);
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <div className={styles.inner} id={id}>
      <div className={styles.wrapper}>
        <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
          <PrismicRichText
            field={slice.primary.title}
            components={components}
          />
        </div>
        <p className={`${styles.subtitle} ${isVisibleStyles}`}>
          {slice.primary.subtitle}
        </p>
      </div>
      <div className={`${styles.navigation} ${isVisibleStyles}`}>
        <ArrowButton
          direction="left"
          onClick={() => {
            navigationRef.current?.prevSlide();
          }}
          buttonStyles={slideNumber.first ? styles.boundarySlide : ''}
          label="back-button"
        />
        <ArrowButton
          direction="right"
          onClick={() => {
            navigationRef.current?.nextSlide();
          }}
          buttonStyles={slideNumber.last ? styles.boundarySlide : ''}
          label="forward-button"
        />
      </div>
      <TestimonialsList
        testimonials={slice.primary.testimonials}
        isVisible={isVisible}
        navigationRef={navigationRef}
        setSlideNumber={setSlideNumber}
      />
    </div>
  );
};
